import React, {Component} from 'react';
import { withRouter } from "react-router-dom";





class Refunds extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Refunds </h2>

                <br/>
               

              
                 <p className='text-primary'>Refunds will be in the next release of BOUNTE  (AUG 2019).  In the meantime, if there is a refund needed or cancel a label, email support@bounte.net </p>


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(Refunds);
